export interface Country {
  code: string;
  name: string;
}

export const NATIONALITIES = {
  AD: { male: 'Andorran', female: 'Andorrane' },
  AE: { male: 'Émirien', female: 'Émirienne' },
  AF: { male: 'Afghan', female: 'Afghane' },
  AG: { male: 'Antiguais-et-Barbudien', female: 'Antiguaise-et-Barbudienne' },
  AI: { male: 'Anguillais', female: 'Anguillaise' },
  AL: { male: 'Albanais', female: 'Albanaise' },
  AM: { male: 'Arménien', female: 'Arménienne' },
  AO: { male: 'Angolais', female: 'Angolaise' },
  AQ: { male: 'Antarctique', female: 'Antarctique' },
  AR: { male: 'Argentin', female: 'Argentine' },
  AS: { male: 'Samoan américain', female: 'Samoa américaine' },
  AT: { male: 'Autrichien', female: 'Autrichienne' },
  AU: { male: 'Australien', female: 'Australienne' },
  AW: { male: 'Arubais', female: 'Arubaise' },
  AX: { male: 'Ålandais', female: 'Ålandaise' },
  AZ: { male: 'Azerbaïdjanais', female: 'Azerbaïdjanaise' },
  BA: { male: 'Bosnien', female: 'Bosnienne' },
  BB: { male: 'Barbadien', female: 'Barbadienne' },
  BD: { male: 'Bangladais', female: 'Bangladaise' },
  BE: { male: 'Belge', female: 'Belge' },
  BF: { male: 'Burkinabé', female: 'Burkinabée' },
  BG: { male: 'Bulgare', female: 'Bulgare' },
  BH: { male: 'Bahreïnien', female: 'Bahreinienne' },
  BI: { male: 'Burundais', female: 'Burundaise' },
  BJ: { male: 'Béninois', female: 'Béninoise' },
  BL: { male: 'Saint-Barthélemy', female: 'Saint-Barthélemy' },
  BM: { male: 'Bermudien', female: 'Bermudienne' },
  BN: { male: 'Brunéien', female: 'Brunéienne' },
  BO: { male: 'Bolivien', female: 'Bolivienne' },
  BQ: { male: 'Bonaire, Saint-Eustache et Saba', female: 'Bonaire, Saint-Eustache et Saba' },
  BR: { male: 'Brésilien', female: 'Brésilienne' },
  BS: { male: 'Bahamien', female: 'Bahamienne' },
  BT: { male: 'Bhoutanais', female: 'Bhoutanaise' },
  BV: { male: 'Île Bouvet', female: 'Île Bouvet' },
  BW: { male: 'Botswanais', female: 'Botswanaise' },
  BY: { male: 'Biélorusse', female: 'Biélorusse' },
  BZ: { male: 'Belizien', female: 'Belizienne' },
  CA: { male: 'Canadien', female: 'Canadienne' },
  CC: { male: 'Îles Cocos', female: 'Îles Cocos' },
  CD: { male: 'Congolais', female: 'Congolaise' },
  CF: { male: 'Centrafricain', female: 'Centrafricaine' },
  CG: { male: 'Congolais', female: 'Congolaise' },
  CH: { male: 'Suisse', female: 'Suisse' },
  CI: { male: 'Ivoirien', female: 'Ivoirienne' },
  CK: { male: 'Cookien', female: 'Cookienne' },
  CL: { male: 'Chilien', female: 'Chilienne' },
  CM: { male: 'Camerounais', female: 'Camerounaise' },
  CN: { male: 'Chinois', female: 'Chinoise' },
  CO: { male: 'Colombien', female: 'Colombienne' },
  CR: { male: 'Costaricain', female: 'Costaricaine' },
  CU: { male: 'Cubain', female: 'Cubaine' },
  CV: { male: 'Cap-verdien', female: 'Cap-verdienne' },
  CW: { male: 'Curaçao', female: 'Curaçao' },
  CX: { male: 'Île Christmas', female: 'Île Christmas' },
  CY: { male: 'Chypriote', female: 'Chypriote' },
  CZ: { male: 'Tchèque', female: 'Tchèque' },
  DE: { male: 'Allemand', female: 'Allemande' },
  DJ: { male: 'Djiboutien', female: 'Djiboutienne' },
  DK: { male: 'Danois', female: 'Danoise' },
  DM: { male: 'Dominiquais', female: 'Dominiquaise' },
  DO: { male: 'Dominicain', female: 'Dominicaine' },
  DZ: { male: 'Algérien', female: 'Algérienne' },
  EC: { male: 'Équatorien', female: 'Équatorienne' },
  EE: { male: 'Estonien', female: 'Estonienne' },
  EG: { male: 'Égyptien', female: 'Égyptienne' },
  EH: { male: 'Sahara occidental', female: 'Sahara occidental' },
  ER: { male: 'Érythréen', female: 'Érythréenne' },
  ES: { male: 'Espagnol', female: 'Espagnole' },
  ET: { male: 'Éthiopien', female: 'Éthiopienne' },
  FI: { male: 'Finlandais', female: 'Finlandaise' },
  FJ: { male: 'Fidjien', female: 'Fidjienne' },
  FK: { male: 'Îles Malouines', female: 'Îles Malouines' },
  FM: { male: 'Micronésien', female: 'Micronésienne' },
  FO: { male: 'Îles Féroé', female: 'Îles Féroé' },
  FR: { male: 'Français', female: 'Française' },
  GA: { male: 'Gabonais', female: 'Gabonaise' },
  GB: { male: 'Britannique', female: 'Britannique' },
  GD: { male: 'Grenadien', female: 'Grenadienne' },
  GE: { male: 'Géorgien', female: 'Géorgienne' },
  GF: { male: 'Guyanais', female: 'Guyanaise' },
  GG: { male: 'Guernesey', female: 'Guernesey' },
  GH: { male: 'Ghanéen', female: 'Ghanéenne' },
  GI: { male: 'Gibraltar', female: 'Gibraltar' },
  GL: { male: 'Groenlandais', female: 'Groenlandaise' },
  GM: { male: 'Gambien', female: 'Gambienne' },
  GN: { male: 'Guinéen', female: 'Guinéenne' },
  GP: { male: 'Guadeloupéen', female: 'Guadeloupéenne' },
  GQ: { male: 'Équato-guinéen', female: 'Équato-guinéenne' },
  GR: { male: 'Hellénique', female: 'Hellénique' },
  GS: {
    male: 'Géorgie du Sud-et-les Îles Sandwich du Sud',
    female: 'Géorgie du Sud-et-les Îles Sandwich du Sud',
  },
  GT: { male: 'Guatémaltèque', female: 'Guatémaltèque' },
  GU: { male: 'Guam', female: 'Guam' },
  GW: { male: 'Bissau-Guinéen', female: 'Bissau-Guinéenne' },
  GY: { male: 'Guyanien', female: 'Guyanaise' },
  HK: { male: 'Hong Kong', female: 'Hong Kong' },
  HM: { male: 'Îles Heard-et-MacDonald', female: 'Îles Heard-et-MacDonald' },
  HN: { male: 'Hondurien', female: 'Hondurienne' },
  HR: { male: 'Croate', female: 'Croate' },
  HT: { male: 'Haïtien', female: 'Haïtienne' },
  HU: { male: 'Hongrois', female: 'Hongroise' },
  ID: { male: 'Indonésien', female: 'Indonésienne' },
  IE: { male: 'Irlandais', female: 'Irlandaise' },
  IL: { male: 'Israélien', female: 'Israélienne' },
  IM: { male: 'Île de Man', female: 'Île de Man' },
  IN: { male: 'Indien', female: 'Indienne' },
  IO: { male: 'Océan Indien Britannique', female: 'Océan Indien Britannique' },
  IQ: { male: 'Irakien', female: 'Irakienne' },
  IR: { male: 'Iranien', female: 'Iranienne' },
  IS: { male: 'Islandais', female: 'Islandaise' },
  IT: { male: 'Italien', female: 'Italienne' },
  JE: { male: 'Jersey', female: 'Jersey' },
  JM: { male: 'Jamaïcain', female: 'Jamaïcaine' },
  JO: { male: 'Jordanien', female: 'Jordanienne' },
  JP: { male: 'Japonais', female: 'Japonaise' },
  KE: { male: 'Kényan', female: 'Kényane' },
  KG: { male: 'Kirghize', female: 'Kirghize' },
  KH: { male: 'Cambodgien', female: 'Cambodgienne' },
  KI: { male: 'Kiribatien', female: 'Kiribatienne' },
  KM: { male: 'Comorien', female: 'Comorienne' },
  KN: { male: 'Kittitien et Névicien', female: 'Kittitienne et Névicienne' },
  KP: { male: 'Nord-coréen', female: 'Nord-coréenne' },
  KR: { male: 'Sud-Coréen', female: 'Sud-Coréenne' },
  KW: { male: 'Koweïtien', female: 'Koweïtienne' },
  KY: { male: 'Îles Caïmans', female: 'Îles Caïmans' },
  KZ: { male: 'Kazakhstanais', female: 'Kazakhstanaise' },
  LA: { male: 'Laotien', female: 'Laotienne' },
  LB: { male: 'Libanais', female: 'Libanaise' },
  LC: { male: 'Saint-Lucien', female: 'Saint-Lucienne' },
  LI: { male: 'Liechtensteinois', female: 'Liechtensteinoise' },
  LK: { male: 'Sri-Lankais', female: 'Sri-Lankaise' },
  LR: { male: 'Libérien', female: 'Libérienne' },
  LS: { male: 'Lesothan', female: 'Lesothane' },
  LT: { male: 'Lituanien', female: 'Lituanienne' },
  LU: { male: 'Luxembourgeois', female: 'Luxembourgeoise' },
  LV: { male: 'Letton', female: 'Lettonne' },
  LY: { male: 'Libyen', female: 'Libyenne' },
  MA: { male: 'Marocain', female: 'Marocaine' },
  MC: { male: 'Monégasque', female: 'Monégasque' },
  MD: { male: 'Moldave', female: 'Moldave' },
  ME: { male: 'Monténégrin', female: 'Monténégrine' },
  MF: { male: 'Saint-Martin (partie française)', female: 'Saint-Martin (partie française)' },
  MG: { male: 'Malgache', female: 'Malgache' },
  MH: { male: 'Marshallais', female: 'Marshallaise' },
  MK: { male: 'Macédonien', female: 'Macédonienne' },
  ML: { male: 'Malien', female: 'Malienne' },
  MM: { male: 'Birman', female: 'Birmane' },
  MN: { male: 'Mongol', female: 'Mongole' },
  MO: { male: 'Macao', female: 'Macao' },
  MP: { male: 'Îles Mariannes du Nord', female: 'Îles Mariannes du Nord' },
  MQ: { male: 'Martinique', female: 'Martinique' },
  MR: { male: 'Mauritanien', female: 'Mauritanienne' },
  MS: { male: 'Montserrat', female: 'Montserrat' },
  MT: { male: 'Maltais', female: 'Maltaise' },
  MU: { male: 'Mauricien', female: 'Mauricienne' },
  MV: { male: 'Maldivien', female: 'Maldivienne' },
  MW: { male: 'Malawien', female: 'Malawienne' },
  MX: { male: 'Mexicain', female: 'Mexicaine' },
  MY: { male: 'Malaisien', female: 'Malaisienne' },
  MZ: { male: 'Mozambicain', female: 'Mozambicaine' },
  NA: { male: 'Namibien', female: 'Namibienne' },
  NC: { male: 'Néo-Calédonien', female: 'Néo-Calédonienne' },
  NE: { male: 'Nigérien', female: 'Nigérienne' },
  NF: { male: 'Norfolkien', female: 'Norfolkienne' },
  NG: { male: 'Nigérian', female: 'Nigériane' },
  NI: { male: 'Nicaraguayen', female: 'Nicaraguayenne' },
  NL: { male: 'Néerlandais', female: 'Néerlandaise' },
  NO: { male: 'Norvégien', female: 'Norvégienne' },
  NP: { male: 'Népalais', female: 'Népalaise' },
  NR: { male: 'Nauruan', female: 'Nauruane' },
  NU: { male: 'Niuean', female: 'Niuéenne' },
  NZ: { male: 'Néo-Zélandais', female: 'Néo-Zélandaise' },
  OM: { male: 'Omanien', female: 'Omanaise' },
  PA: { male: 'Panaméen', female: 'Panaméenne' },
  PE: { male: 'Péruvien', female: 'Péruvienne' },
  PF: { male: 'Polynésien français', female: 'Polynésienne française' },
  PG: { male: 'Papouan-Néo-Guinéen', female: 'Papouane-Néo-Guinéenne' },
  PH: { male: 'Philippin', female: 'Philippine' },
  PK: { male: 'Pakistanais', female: 'Pakistanaise' },
  PL: { male: 'Polonais', female: 'Polonaise' },
  PM: { male: 'Saint-Pierre-et-Miquelon', female: 'Saint-Pierre-et-Miquelon' },
  PN: { male: 'Îles Pitcairn', female: 'Îles Pitcairn' },
  PR: { male: 'Porto Ricain', female: 'Porto Ricaine' },
  PS: { male: 'Palestinien', female: 'Palestinienne' },
  PT: { male: 'Portugais', female: 'Portugaise' },
  PW: { male: 'Palaosien', female: 'Palaosienne' },
  PY: { male: 'Paraguayen', female: 'Paraguayenne' },
  QA: { male: 'Qatarien', female: 'Qatarienne' },
  RE: { male: 'Réunion', female: 'Réunion' },
  RO: { male: 'Roumain', female: 'Roumaine' },
  RS: { male: 'Serbe', female: 'Serbe' },
  RU: { male: 'Russe', female: 'Russe' },
  RW: { male: 'Rwandais', female: 'Rwandaise' },
  SA: { male: 'Saoudien', female: 'Saoudienne' },
  SB: { male: 'Salomonais', female: 'Salomonaise' },
  SC: { male: 'Seychellois', female: 'Seychelloise' },
  SD: { male: 'Soudanais', female: 'Soudanaise' },
  SE: { male: 'Suédois', female: 'Suédoise' },
  SG: { male: 'Singapourien', female: 'Singapourienne' },
  SH: { male: 'Sainte-Hélène', female: 'Sainte-Hélène' },
  SI: { male: 'Slovène', female: 'Slovène' },
  SJ: { male: 'Svalbard et Île Jan Mayen', female: 'Svalbard et Île Jan Mayen' },
  SK: { male: 'Slovaque', female: 'Slovaque' },
  SL: { male: 'Sierra-Léonais', female: 'Sierra-Léonaise' },
  SM: { male: 'Saint-Marinais', female: 'Saint-Marinaise' },
  SN: { male: 'Sénégalais', female: 'Sénégalaise' },
  SO: { male: 'Somalien', female: 'Somalienne' },
  SR: { male: 'Surinamais', female: 'Surinamaise' },
  SS: { male: 'Sud-Soudanais', female: 'Sud-Soudanaise' },
  ST: { male: 'Santoméen', female: 'Santoméenne' },
  SV: { male: 'Salvadorien', female: 'Salvadorienne' },
  SX: {
    male: 'Saint-Martinois (partie néerlandaise)',
    female: 'Saint-Martinoise (partie néerlandaise)',
  },
  SY: { male: 'Syrien', female: 'Syrienne' },
  SZ: { male: 'Swazi', female: 'Swazie' },
  TC: { male: 'Îles Turques-et-Caïques', female: 'Îles Turques-et-Caïques' },
  TD: { male: 'Tchadien', female: 'Tchadienne' },
  TF: { male: 'Terres australes françaises', female: 'Terres australes françaises' },
  TG: { male: 'Togolais', female: 'Togolaise' },
  TH: { male: 'Thaïlandais', female: 'Thaïlandaise' },
  TJ: { male: 'Tadjik', female: 'Tadjike' },
  TK: { male: 'Tokelau', female: 'Tokelau' },
  TL: { male: 'Est-timorais', female: 'Est-timoraise' },
  TM: { male: 'Turkmène', female: 'Turkmène' },
  TN: { male: 'Tunisien', female: 'Tunisienne' },
  TO: { male: 'Tonguien', female: 'Tonguienne' },
  TR: { male: 'Turc', female: 'Turque' },
  TT: { male: 'Trinidadien', female: 'Trinidadienne' },
  TV: { male: 'Tuvaluan', female: 'Tuvaluane' },
  TW: { male: 'Taïwanais', female: 'Taïwanaise' },
  TZ: { male: 'Tanzanien', female: 'Tanzanienne' },
  UA: { male: 'Ukrainien', female: 'Ukrainienne' },
  UG: { male: 'Ougandais', female: 'Ougandaise' },
  UM: {
    male: 'Îles mineures éloignées des États-Unis',
    female: 'Îles mineures éloignées des États-Unis',
  },
  US: { male: 'Américain', female: 'Américaine' },
  UY: { male: 'Uruguayen', female: 'Uruguayenne' },
  UZ: { male: 'Ouzbek', female: 'Ouzbèke' },
  VA: { male: 'Vatican', female: 'Vaticane' },
  VC: { male: 'Saint-Vincentais et Grenadien', female: 'Saint-Vincentaise et Grenadine' },
  VE: { male: 'Vénézuélien', female: 'Vénézuélienne' },
  VG: { male: 'Îles vierges britanniques', female: 'Îles vierges britanniques' },
  VI: { male: 'Îles vierges américaines', female: 'Îles vierges américaines' },
  VN: { male: 'Vietnamien', female: 'Vietnamienne' },
  VU: { male: 'Vanuatuan', female: 'Vanuatuane' },
  WF: { male: 'Wallis-et-Futuna', female: 'Wallis-et-Futuna' },
  WS: { male: 'Samoan', female: 'Samoane' },
  XK: { male: 'Kosovo', female: 'Kosovo' },
  YE: { male: 'Yéménite', female: 'Yéménite' },
  YT: { male: 'Mayotte', female: 'Mayotte' },
  ZA: { male: 'Sud-Africain', female: 'Sud-Africaine' },
  ZM: { male: 'Zambien', female: 'Zambienne' },
  ZW: { male: 'Zimbabwéen', female: 'Zimbabwéenne' },
};
